export class RenderUnsupportedError extends Error {
  constructor(feature: string, message?: string) {
    super(message ?? `Rendering is not supported in this browser because ${feature} is unavailable.`)
    this.name = 'RenderUnsupportedError'
  }
}
